import styled from '@emotion/styled';
import { Button, focusVisibleStyles, pxToRem } from '@lbcamden/lib-react';

export const DocumentUploadField = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const DocumentSelectButton = styled(Button)`
  ${focusVisibleStyles('button', { focusWithin: true })}

  position: relative;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.primaryHover};
  }

  svg {
    height: ${pxToRem(14)};
  }

  input[type='file'] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    opacity: 0;

    ::-webkit-file-upload-button {
      cursor: pointer;
    }
  }
`;
